/** The two caller-verification scopes a tool can run under. */

export const BASE_SCOPE = 'partner_user';
export const VERIFIED_SCOPE = 'partner_user:verified';
export type ToolScope = typeof BASE_SCOPE | typeof VERIFIED_SCOPE;

/** Coerce a stored required_scope string to a known option (anything else falls back to base). */
export const normalizeToolScope = (scope: string | undefined): ToolScope =>
  scope === VERIFIED_SCOPE ? VERIFIED_SCOPE : BASE_SCOPE;
